'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { LinkIcon } from 'lucide-react';
import { CopySectionUrl } from '@/modules/shared/components/section-title/copy-section-url';
import { TooltipInfoIcon } from '@/modules/shared/components/tooltip-info-icon/tooltip-info-icon';
import ff from '@/modules/shared/lib/feature-flags';
export interface TitleBreakdownChartProps {
  title: string;
  hash: string;
  className?: string;
  tooltipContent: React.ReactNode;
  range: string;
}
function TitleSectionFinances(t0) {
  const $ = _c(19);
  const {
    title,
    hash,
    className,
    tooltipContent,
    range
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex w-fit items-center gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <span className="text-base leading-[120%] font-bold lg:text-lg 2xl:text-xl">{title}</span>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== tooltipContent) {
    t3 = <TooltipInfoIcon tooltipContent={<div>{tooltipContent}</div>} />;
    $[4] = tooltipContent;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LinkIcon className="size-4" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== hash) {
    t5 = <CopySectionUrl hash={hash}>{t4}</CopySectionUrl>;
    $[7] = hash;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t5) {
    t6 = <div className={t1}>{t2}{t3}{t5}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== range) {
    t7 = ff.finances.YEAR_SELECTOR_ENABLED && <div className="text-base/6 font-semibold opacity-30">{range}</div>;
    $[14] = range;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="flex flex-col gap-1">{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
export { TitleSectionFinances };